import { render, staticRenderFns } from "./LoginContainer.vue?vue&type=template&id=01985a10&"
import script from "./LoginContainer.vue?vue&type=script&lang=ts&"
export * from "./LoginContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports